import { GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { s3Client } from "@/shared/s3-client";
import type {
  FirmaAdendumDocumentosResponse,
  FirmaAdendumEstadoResponse,
  FirmaAdendumReenviarResponse,
  FirmaAdendumTramitesResponse,
} from "@/erp/campanas/firma-adendum";

const { get, post } = erpApi();

const FIRMA_BASE = `${urlBackend}api/v1/firma-transaccional`;

const FIRMA_PDF_BUCKET = "adendum";

export const getFirmaAdendumTramites = async (
  cedula?: string,
  page = 1,
  pageSize = 10,
): Promise<FirmaAdendumTramitesResponse> => {
  const params = new URLSearchParams();
  if (cedula && cedula.trim() !== "") {
    params.set("cedula", cedula.trim());
  }
  params.set("page", String(page));
  params.set("page_size", String(pageSize));

  const response = await get<FirmaAdendumTramitesResponse>(
    `${FIRMA_BASE}/tramites/?${params.toString()}`,
    true,
  );

  return response as unknown as FirmaAdendumTramitesResponse;
};

export const getFirmaAdendumEstado = async (
  noTramite: string,
): Promise<FirmaAdendumEstadoResponse> => {
  const response = await get<FirmaAdendumEstadoResponse>(
    `${FIRMA_BASE}/tramites/${encodeURIComponent(noTramite)}/estado/`,
    true,
  );

  return response as unknown as FirmaAdendumEstadoResponse;
};

export const getFirmaAdendumDocumentos = async (
  noTramite: string,
): Promise<FirmaAdendumDocumentosResponse> => {
  const response = await get<FirmaAdendumDocumentosResponse>(
    `${FIRMA_BASE}/tramites/${encodeURIComponent(noTramite)}/documentos/`,
    true,
  );

  return response as unknown as FirmaAdendumDocumentosResponse;
};

export const reenviarFirmaAdendumLink = async (
  noTramite: string,
  cedula: string,
  horasExtension?: number,
): Promise<FirmaAdendumReenviarResponse> => {
  const body =
    typeof horasExtension === "number" && horasExtension > 0
      ? { horasExtension }
      : {};

  const response = await post<FirmaAdendumReenviarResponse>(
    `${FIRMA_BASE}/tramites/${encodeURIComponent(noTramite)}/firmantes/${encodeURIComponent(cedula)}/reenviar/`,
    body,
    true,
  );

  return response as unknown as FirmaAdendumReenviarResponse;
};

export const getFirmaAdendumPdfUrl = async (
  rutaPdf: string,
): Promise<string> => {
  const command = new GetObjectCommand({
    Bucket: FIRMA_PDF_BUCKET,
    Key: rutaPdf,
  });

  return await getSignedUrl(s3Client, command, { expiresIn: 300 });
};

export const getFirmaAdendumPdfName = (rutaPdf: string): string => {
  const parts = rutaPdf.split("/");
  return parts[parts.length - 1] || rutaPdf;
};
